exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3611f6d0] .el-table th>.cell{font-weight:700}.el-tabs__content[data-v-3611f6d0]{padding-left:10px}", ""]);

// exports
